"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file has private sentinal values that are necessary to implement
 * certain transformations.
 */
exports.RV_SENTINAL = Symbol('rv_sentinal');
exports.EXN_SENTINAL = Symbol('exn_sentinal');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VudGluZWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3J1bnRpbWUvc2VudGluZWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7OztHQUdHO0FBQ1UsUUFBQSxXQUFXLEdBQUcsTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFDO0FBQ3BDLFFBQUEsWUFBWSxHQUFHLE1BQU0sQ0FBQyxjQUFjLENBQUMsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/runtime/sentinels.js
// module id = 819
// module chunks = 0